import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isNil } from 'lodash';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import styles from './popup-stepped-message.css';
export function PopupSteppedMessage(props) {
    const { children } = props;
    return (_jsx("div", { className: styles.wrapper, ...assignTestId('stepped-message'), children: children
            .filter(child => !isNil(child))
            .map((child, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        _jsxs("div", { className: styles.messageRow, children: [_jsx("div", { className: styles.massageDot }), _jsx("div", { className: styles.message, children: child })] }, idx))) }));
}
